<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import TeaserCard from './TeaserCard'

  export default {
    name: 'LandingPageTeaserModule',
    components: {
      TeaserCard,
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
  }
</script>
